export const reservas = {
    // Filtro con el que llega el listado desde las cajas del dashboard
    filtroLlegadas: {
        today: `Chegadas de hoje`,
        tomorrow: `Chegadas de amanhã`,
        this_week: `Chegadas desta semana`,
        month: `Chegadas deste mês`,
        upcoming: `Próximas chegadas`,
    },
    filtroSalidas: {
        today: `Saídas de hoje`,
    },
    quitarFiltro: `Remover filtro`,
    // Estancia vendida por horas registrada como reserva
    rapida: `Rápida`,
    p1:`Lista de reservas`,
    p2:`Lista de reservas registradas na plataforma`,
    p3:`Mais ações`,
    p4:`Agendar check-in`,
    p5:`Hoje`,
    p6:`Código da reserva`,
    p7:`Nome`,
    p8:`E-mail`,
    p9:`Data do check-in`,
    p10:`Depósito`,
    p11:`Número de hóspedes`,
    p12:`Status: `,
    p13:`Valor: `,
    p14:`Status: `,
    p15:`Pendente`,
    p16:`Concluído`,

    p17:`Mais ações`,
    p18:`Importar reservas`,
    p19:`Baixe um modelo do Excel, preencha os dados das suas reservas e faça o upload para criar várias reservas de uma vez.`,

    p20:`Check-in agendado`,
    p21:`Informações detalhadas do check-in agendado`,
    p22:`Status: `,
    p23:`Pago`,
    p24:`Pagamento pendente`,
    p25:`Alterar status do pagamento`,
    p26:`Responsável pelo check-in`,
    p27:`Enviar check-in online`,
    p28:`Enviando link de check-in...`,
    p29:`Enviar o link de check-in online aos hóspedes automaticamente`,
    p30:`Uma semana antes do check-in`,
    p31:`72 horas antes do check-in`,
    p32:`48 horas antes do check-in`,
    p33:`24 horas antes do check-in`,
    p34:`Salvar alterações`,
    p35:`Data do check-in`,
    p36:`Data do check-out`,
    p37:`Hóspedes registrados`,
    p38:`Lista de check-ins concluídos`,
    p39:`Nome`,
    p41:`Sobrenome`,
    p42:`Data do check-in`,
    p43:`E-mail`,
    p44:`Processo`,
    p45:`Escaneado`,
    p46:`Manual`,
    p47:`Manual do operador`,
    p48:`Telefone`,
    p49:`Nenhum check-in registrado`,

    p50:`Status do pagamento da reserva`,
    p51:`Altere manualmente o status do pagamento da reserva.`,
    p52:`Selecione uma das opções`,
    p53:`Pendente`,
    p54:`Pago`,
    p55:`Cancelar`,
    p56:`Alterar status`,
    p57:`Não especificado`,
    p58:`Concluído`,
    p59:`Nenhuma reserva registrada ainda`,
    p60:`Check-ins agendados`,
    p61:`Alterações salvas com sucesso`,
    p62:`Deseja enviar o link de check-in?`,
    p63:`Enviar link`,
    p64:`Cancelar`,
    p65:`Solicitação de check-in enviada com sucesso`,

    p66:`Propriedade ou usuário não encontrado.`,
    p67:`Erro ao gerar o token`,
    p68:`Erro ao conectar com o canal. Por favor, tente novamente.`,
    p69:`Disponibilidade e tarifas`,
    p70:`Gerencie os dias disponíveis e as tarifas da sua hospedagem`,
    p71:`Para ativar este recurso, você precisa de um plano ativo. Você poderá ver a disponibilidade da sua hospedagem na hora, ajustar as tarifas conforme a temporada ou eventos especiais e gerenciar tudo em um só lugar.`,
    p72:`Ao cancelar esta reserva, as datas ficarão disponíveis em qualquer portal conectado`,
    p73:`Cancelar reserva`,
    p74:`Reserva cancelada com sucesso`,
    p75:`Reserva de `,
    p76:` cancelada.`,
    p77:`Você não pode reservar em datas bloqueadas.`,
    p78:`Verifique as datas selecionadas`,
    p79:`Você precisa selecionar pelo menos uma noite para a reserva.`,
    p80:`As datas selecionadas não estão disponíveis.`,
    p81:`Lembretes`,
    p82:`Gerencie os lembretes para seus hóspedes`,
    p83:`Criar novo lembrete`,
    p84:`Dia`,
    p85:`Horário`,
    p86:`Descrição`,
    p87:`Excluir lembrete`,
    p88:`Nenhum lembrete encontrado`,
    p89:`Tem certeza de que deseja excluir o lembrete?`,
    p90:`Você perderá os dados salvos`,
    p91:`Excluir lembrete`,
    p92:`Lembrete excluído com sucesso`,
    p93:`Primeiro passo:`,
    p94:`Selecione o país onde você tem reservas e baixe o modelo para preencher os dados.`,
    p95:`Baixar modelo`,
    p96:`Segundo passo:`,
    p97:`Faça o upload do(s) mesmo(s) modelo(s) que você baixou com os dados preenchidos.`,
    p98:`Importar`,
    p99:`Você precisa fazer o upload do modelo para continuar com a importação`,
    p100:`Processo concluído com sucesso`,
    p101:`Erro durante o processo de importação`,
    p102:`Disponível`,
    p103:`Ocupado`,
    p104:`Limpeza`,
    p105:`Manutenção`,
    p106:`Erro ao cancelar a reserva`,
    p107:`Erro ao atualizar a visualização após o cancelamento`,
    p108:`Não foi possível abrir a troca de quarto. Reserva inválida.`,
    p109:`Não foi possível identificar o quarto atual.`,
    p110:`Disponibilidade atualizada com sucesso`,
    p111:`Calendário do hotel`,
    p112:`Gerencie suas reservas de forma visual e mantenha o controle total da disponibilidade do seu hotel.`,
    p113:`Alterar disponibilidade`,
    p114:`Criar reserva`,
    p115:`As reservas pausadas não serão enviadas automaticamente`,
    p116:`O envio automático será ativado para esta reserva`,
    p117:`Pausar`,
    p118:`Ativar`,
    p119:`a reserva`,
    p120:`Sim`,
    p121:`Reserva pausada com sucesso`,
    p122:`Processo concluído com sucesso`,
    p123:`Reserva ativada com sucesso`,
    p124:`Reservas sincronizadas e criadas manualmente`,
    p125:`Data inválida`,
    p126:`Data inválida`,
    p127:`O convite de check-in será enviado em `,
    p128:`Reserva pausada`,
    p129:`Reserva cancelada`,
    p130:`Concluído`,
    p131:`Todas as suas reservas com os detalhes de cada check-in e hóspede aparecerão aqui. Quando você receber sua primeira reserva, ela aparecerá bem aqui.`,
    p132:`Propriedade selecionada`,
    p133:`Múltiplas`,
    p134:`Mensal`,
    p135:`Fechado`,
    p136:`Datas atualizadas com sucesso`,
    p137:`Erro ao carregar os dados da propriedade`,
    p138:`As datas selecionadas não estão disponíveis. Há reservas ou datas fechadas causando conflito.`,
    p139:`Reserva criada com sucesso`,
    p140:`Intervalo`,
    p141:`fechado com sucesso`,
    p142:`Erro ao bloquear datas`,
    p143:`Erro ao remover datas fechadas`,
    p144:`Preços atualizados com sucesso`,
    p145:`Erro ao atualizar preços`,
    p146:`Tem certeza de que deseja cancelar esta reserva?`,
    p147:`Confirmar cancelamento`,
    p148:`Sim, cancelar`,
    p149:`Não`,
    p150:`Reserva cancelada com sucesso`,
    p151:`Erro ao carregar as propriedades`,
    p152:`Nova reserva adicionada ao calendário`,
    p153:`Esta reserva vem de um canal externo (OTA). Não é recomendável cancelá-la diretamente por este sistema. Por favor, entre em contato com o hóspede e peça para que ele cancele a reserva pelo canal de origem.`,
    p154:`Reserva de OTA - Cancelamento não permitido`,
    p155:`Entendi`,
    p156:`Erro ao processar a solicitação`,
    p157:`Link copiado com sucesso`,
    p158:`Copiado!`,
    p159:`Ocorreu um erro ao copiar o link`,
    p160:`Erro`,
    p161:`Enviar check-in ao responsável pela reserva`,
    p162:`Enviar check-in`,
    p163:`Enviar`,
    p164:`Erro ao carregar a reserva`,
    p165:`Informações do check-in`,
    p166:`Enviar solicitação de check-in`,
    p167:`Todas as reservas`,
    p168:`Próximas reservas`,
    p169:`Reservas canceladas`,
    p170:`Hóspedes`,
    p171:`Data do check-in`,
    p172:`Check-in`,
    p173:`Reservada`,
    p174:`Overbooking`,
    p175:`Cancelada`,
    p176:``,
    p177:``,
    p178:``,
    p179:``,
    p180:``,
    p181:``,
    p182:``,
    p183:``,
}
